import { Button } from '@shadcn/ui/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@shadcn/ui/components/ui/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shadcn/ui/components/ui/tooltip';
import { cn } from '@shadcn/ui/lib/utils';
import { GET_CONTACT_BY_ID, GET_CONTACTS_WEIGHTED_SCORES, MARK_ACTION_AS_NOT_INTERESTED } from '@zaplify/graphql';
import { Calendar, EllipsisVertical, X } from 'lucide-react';
import { FC } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useToast } from '@shadcn/ui/hooks/use-toast';

export const ActionCardOptionsButton: FC<{
    className?: string;
    contactId: string;
    openSnoozeDialogForContact: (contactFirstName: string, contactId: string) => void;
}> = ({ className, contactId, openSnoozeDialogForContact }) => {
    const [markActionAsNotInterested] = useMutation(MARK_ACTION_AS_NOT_INTERESTED);
    const { toast } = useToast();

    const { data } = useQuery(GET_CONTACT_BY_ID, {
        variables: { id: contactId },
    });

    const handleMarkActionAsNotInterested = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        markActionAsNotInterested({
            variables: { contactId },
            refetchQueries: [GET_CONTACTS_WEIGHTED_SCORES],
        }).then(() => {
            toast({
                title: 'Marked as not interested',
            });
        });
    };

    const handleSnoozeAction = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        openSnoozeDialogForContact(data?.Contacts_by_pk?.firstName || '', contactId);
    };
    return (
        <DropdownMenu>
            <Tooltip>
                <TooltipTrigger asChild>
                    <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="icon-sm" className={cn(className)}>
                            <EllipsisVertical className="w-4 h-4 text-gray-500 flex-shrink-0" />
                        </Button>
                    </DropdownMenuTrigger>
                </TooltipTrigger>
                <TooltipContent>
                    <p>Options</p>
                </TooltipContent>
            </Tooltip>
            <DropdownMenuContent>
                <DropdownMenuItem onClick={handleMarkActionAsNotInterested}>
                    <X className="w-4 h-4 text-gray-500 flex-shrink-0" />
                    <span>Not interested</span>
                </DropdownMenuItem>
                {/* <DropdownMenuItem className="group/re-surface">
                    <div className="relative flex items-end">
                        <Clock className="w-4 h-4 text-gray-500 flex-shrink-0" />
                        <Sparkles className="w-3 h-3 text-text-brand-secondary flex-shrink-0 bg-background-primary rounded-full p-[1px] absolute -bottom-1 -right-1 group-hover/re-surface:bg-accent transition-colors duration-100" />
                    </div>
                    <span>Re-surface another time</span>
                </DropdownMenuItem> */}
                <DropdownMenuItem onClick={handleSnoozeAction}>
                    <Calendar className="w-4 h-4 text-gray-500 flex-shrink-0" />
                    <span>Snooze...</span>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
